import { useEffect, useCallback, useRef, useState } from 'react';

/**
 * Custom hook for infinite scroll functionality
 * @param {Function} loadMore - Function to call when more data needs to be loaded
 * @param {boolean} hasNextPage - Whether there are more pages to load
 * @param {boolean} isLoading - Whether data is currently being loaded
 * @param {number} threshold - Distance from bottom to trigger load (default: 100px)
 * @returns {Object} - { containerRef, isLoadingMore }
 */
const useInfiniteScroll = (loadMore, hasNextPage, isLoading, threshold = 100) => {
  const containerRef = useRef(null);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const handleScroll = useCallback(() => {
    if (!containerRef.current || isLoading || !hasNextPage || isLoadingMore) {
      // console.log('Infinite scroll blocked:', {
      //   hasContainer: !!containerRef.current,
      //   isLoading,
      //   hasNextPage,
      //   isLoadingMore
      // });
      return;
    }

    const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
    const distanceFromBottom = scrollHeight - scrollTop - clientHeight;

    console.log('Scroll metrics:', {
      scrollTop,
      scrollHeight,
      clientHeight,
      distanceFromBottom,
      threshold
    });

    if (distanceFromBottom < threshold) {
      console.log('Triggering loadMore...');
      setIsLoadingMore(true);
      loadMore().finally(() => {
        setIsLoadingMore(false);
      });
    }
  }, [loadMore, hasNextPage, isLoading, isLoadingMore, threshold]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return {
    containerRef,
    isLoadingMore
  };
};

export default useInfiniteScroll;